<template>
    <a-popover
        :visible="popupVisible"
        :overlayClassName="'filterMenu no-padding'"
        placement="bottom"
        @visibleChange="(isVisible) => (popupVisible = isVisible)"
        trigger="click"
        v-if="translatedItems.length"
        key="contact-group-button"
    >
        <div slot="content">
            <div class="group-list-wrapper filter-list-bg">
                <div class="custom-list">
                    <div
                        class="custom-list-item"
                        v-for="item in translatedItems"
                        :key="item.key"
                        @click="() => change(item.key)"
                    >
                        <span class="material-icons">{{ item.materialIcon || "layers" }}</span>
                        {{ item.label }}
                    </div>
                </div>
            </div>
        </div>
        <div class="add-sort-button">
            <span class="material-icons"> layers </span>
            <div class="add-button-text" v-if="contactListGroupBy">
                {{ $t("chatWindow.groupBy") }} : {{ getLabel(contactListGroupBy) }}
            </div>
            <div class="add-button-text" v-else>{{ $t("chatWindow.selectFilter") }}</div>
            <span class="material-icons"> arrow_drop_down </span>
        </div>
    </a-popover>
</template>

<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";

export default Vue.extend({
    name: "ContactGroupButton",
    computed: {
        ...mapState({
            contactListGroupBy: (state) => state.chat.contactListGroupBy,
        }),
        translatedItems() {
            return this.items.map((item) => ({
                ...item,
                label: this.$t(`chatWindow.${item.key}`),
            }));
        },
    },

    data() {
        return {
            popupVisible: false,
            items: [
                {
                    key: "none",
                    materialIcon: "layers",
                },
                {
                    key: "agent",
                    materialIcon: "person",
                },
                {
                    key: "department",
                    materialIcon: "business",
                },
            ],
        };
    },
    methods: {
        ...mapActions({
            setContactListGroupBy: "chat/setContactListGroupBy",
        }),
        change(key) {
            console.log("change", key);
            this.setContactListGroupBy(key);
            this.popupVisible = false;
        },
        getLabel(key) {
            return this.translatedItems.find((x) => x.key === key)?.label;
        },
    },
});
</script>

<style lang="scss" scoped>
.group-list-wrapper {
    display: flex;
    flex-direction: column;
    max-height: 99vh;
    max-width: 300px;
    overflow: hidden;

    .custom-list {
        overflow-x: hidden;
        overflow-y: auto;

        .custom-list-item {
            align-items: center;
            cursor: pointer;
            display: flex;
            height: 35px;
            padding: 0 16px;
            transition: all 0.3s;
            width: 100%;
            background: #f5f7fa;
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #22272d;
            font-weight: 400;
            font-size: 15px;
            line-height: 19px;

            .material-icons {
                color: #008aff;
                font-size: 14px;
                margin-right: 10px;
                transition: all 0.3s;
            }

            &:hover {
                background: #008aff;
                color: #fff;
                opacity: 0.8;

                .material-icons {
                    color: #fff;
                }
            }
        }

        .custom-list-item:first-child {
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
        }
    }
}

.ant-popover.no-padding {
    .ant-popover-inner-content {
        padding: 0 !important;
        width: auto;
    }
}

.add-sort-button {
    display: flex;
    align-items: center;
    width: fit-content !important;
    height: 32px;
    cursor: pointer;
    transition: all 0.3s;
    background: #fff;
    color: #22272d;
    font-family: Source Sans Pro, sans-serif;
    text-align: center;
    user-select: none;

    margin: unset !important;
    border-radius: 20px;
    border: 1px dashed var(--color-border-default);
    font-size: 12px;
    font-weight: 600;
    line-height: 24px;
    padding: 1px 5px !important;
    min-width: fit-content;

    .material-icons {
        font-size: 15px;
        margin-right: 3px;
    }

    .material-icons {
        color: #006cff;
    }

    &:hover {
        opacity: 0.8;
    }
}
</style>
